import { createAnalyticsClient } from '@charlava-com/jamcam-analytics/browser';
import type {
  AnalyticsEventName,
  EventProps,
} from '@charlava-com/jamcam-analytics/contract';
const client = createAnalyticsClient();
let stageContext: EventProps = {};
export function initJamCamAnalytics({ apiUrl }: { apiUrl: string }) {
  const base = apiUrl.replace(/\/$/, '');
  client.init({
    endpoint: `${base}/analytics/events`,
    authEndpoint: `${base}/services/jamcam/analytics/events`,
    source: 'jamcam-app',
  });
}
export const setAnalyticsAuth = client.setAuth;
export function trackJC(event: AnalyticsEventName, props: EventProps = {}) {
  client.track(event, {
    ...(event === 'practice_run_completed' ? stageContext : {}),
    ...props,
  });
}
export const trackJCOnce = client.trackOnce;
export const flushJamCamAnalytics = client.flush;
export function setStageAnalyticsContext(context: EventProps) {
  stageContext = context;
}
export const _resetJamCamAnalytics = client.reset;
